import React from 'react'
import { Form } from 'react-bootstrap'
import classNames from 'classnames'

/**
 * Form Checkbox Component based on CardSelectionCheckbox styling
 */
const FormCheckbox = ({
  checkboxId,
  isChecked,
  onChange,
  label,
  disabled = false,
  className,
  ...rest
}) => {
  return (
    <Form.Group className='mb-0 align-self-center me-3 custom-checkbox'>
      <Form.Check
        id={checkboxId}
        custom={true}
        onChange={onChange}
        checked={isChecked}
        type='checkbox'
        className={classNames(
          {
            'cursor-pointer': !disabled,
            'cursor-disabled': disabled,
          },
          className,
        )}
        disabled={disabled}
        {...rest}>
        <Form.Check.Input
          id={checkboxId}
          onChange={onChange}
          checked={isChecked}
          type='checkbox'
          className={classNames(
            {
              'cursor-pointer': !disabled,
              'cursor-disabled': disabled,
            },
            className,
          )}
          disabled={disabled}
          {...rest}
        />
        <Form.Check.Label
          className={classNames('checkbox-label ms-2 text-uppercase s8', {
            'cursor-pointer': !disabled,
            'cursor-disabled': disabled,
          })}>
          {label}
        </Form.Check.Label>
      </Form.Check>
    </Form.Group>
  )
}

export default FormCheckbox
